import React, { useEffect, useState } from 'react';
import './ContactPage.css';
import { FaUser, FaPhone, FaEnvelope, FaEdit, FaTrash, FaPlus, FaBuilding } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';
import { selectUserExists } from '../redux/userSlice';
import Accordion from './Accordion';

const ContactPage = () => {
  const [contact, setContact] = useState([])

  const navigate = useNavigate();



  const deleteContact = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      axios.delete(`${Base_Url}/contact/${id}`)
        .then(response => {
          // Handle any other logic after successful deletion if needed
          fetchLatestConvocationYear()
        })
        .catch(error => {
          console.error('Error deleting item:', error);
          // Handle error state or notify the user
        });
    }
  };
  const fetchLatestConvocationYear = async () => {
    try {
      const response = await axios.get(`${Base_Url}/contact`);

      // Log the raw response data
      setContact(response.data)
      // console.log('API response:', response.data);
      // Assuming the response is an array of objects with `convocation_id` and `year`
      const data = response.data; // Adjust this if your response structure is different

      // Check if data is an array
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchLatestConvocationYear()
  }, [])

  const userfromwebmaster = useSelector((state) => state.user);
  const statecsc = useSelector((state) => state.statecsc)
  return (
    <div className="contact-page">
      <div className="d-flex justify-content-center align-items-center mb-4">
        <h1 style={{ color: "#c21717" }}>Contact Us</h1>
        {
          (userfromwebmaster.userExists || statecsc.userState === 0) && <>  <Link to="/add-contact">
            <FaPlus className='mb-4 ms-2' />
          </Link>
          </>
        }

      </div>
      
      <div className="contact-info">
        {Array.isArray(contact) && contact.length > 0 && contact?.map((elem, index) => (
          <div key={index} className="contact-card">
            <FaUser className="icon" />
            <h2>{elem.title}</h2>
            <p><FaPhone className="inline-icon" /> {elem.phone}</p>
            <p><FaEnvelope className="inline-icon" /> {elem.email}</p>
            <p><FaBuilding className="inline-icon" /> {elem.location}</p>
            {
              (userfromwebmaster.userExists || statecsc.userState === 0) && <>
                <div className="card-actions">
                  <FaEdit className="action-icon edit" onClick={() => navigate(`/edit-contact/${elem.id}`)} />
                  <FaTrash className="action-icon delete" onClick={() => deleteContact(elem.id)} />
                </div>

              </>
            }
          </div>
        ))}

      </div>
      <section>
        <Accordion />
      </section>
      
      <section className="service gray-bg page-section-ptb">
        <div className="container">
          <div className="row">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1473.5974638038313!2d77.1904289489299!3d28.5449740065277!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x90021d25eee641fc!2sComputer+Services+Centre!5e0!3m2!1sen!2sin!4v1557489417827!5m2!1sen!2sin" style={{ border: 0, width: '100%', height: '500px' }}
              title="IIT Delhi Map"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactPage;
